import { Injectable } from '@angular/core';
import { AuthGuardService } from '@shared/services/auth-guard.service';

@Injectable()
export class DestroyPermission {
  constructor(protected authGuardService: AuthGuardService) {}

  public get hasListPermission(): boolean {
    return this.authGuardService.checkPermission(['pm_dt_v']);
  }

  public get hasRequestListPermission(): boolean {
    return this.authGuardService.checkPermission(['pm_dt_req_v']);
  }
}
